export enum StringOptionsValue {
  Contains = 'contains',
  NotContain = 'does_not_contain',
  OnlyContains = 'only_contains',
  Known = 'known',
  Unknown = 'unknown',
}
